import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "coupon_bg relative w-[400px] pb-[20px] rounded-[24px] box-border text-[#835429]",
  style: {"position":"relative","width":"400px","padding-bottom":"20px","border-radius":"24px","color":"#835429"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "absolute top-[-10px]",
  src: "https://static-s.theckb.com/BusinessMarket/SEO/activity_dialog_bg.png",
  style: {"position":"absolute","top":"-10px","max-width":"100%"},
  alt: ""
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "p-[20px] relative",
  style: {"padding":"20px","position":"relative"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-[4px] text-3xl font-bold text-[#331C0A] pt-[10px]",
  style: {"margin-top":"4px","font-size":"18px","font-weight":"700","color":"#331C0A","padding-top":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-[#E95941]",
    style: {"color":"#E95941"}
  }, "国際配送無料"),
  /*#__PURE__*/_createTextVNode("のご優待 ")
], -1)
const _hoisted_5 = {
  class: "mt-[4px] text-base opacity-60",
  style: {"margin-top":"14px","font-size":"12px","opacity":"0.6"}
}
const _hoisted_6 = {
  key: 1,
  class: "p-[20px] relative",
  style: {"padding":"20px","position":"relative"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-[4px] text-3xl font-bold text-[#331C0A] pt-[10px]",
  style: {"margin-top":"4px","font-size":"18px","font-weight":"700","color":"#331C0A","padding-top":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-[#E95941]",
    style: {"color":"#E95941"}
  }, "国際配送無料"),
  /*#__PURE__*/_createTextVNode("のご優待 ")
], -1)
const _hoisted_8 = {
  class: "mt-[4px] text-base opacity-60",
  style: {"margin-top":"14px","font-size":"12px","opacity":"0.6"}
}
const _hoisted_9 = {
  class: "mx-[24px] mt-[40px] w-[352px] h-[118px] bg-[url(https://static-s.theckb.com/BusinessMarket/SEO/activity_coupon_118.png)] bg-contain flex",
  style: {"margin":"40px 24px 0 24px","width":"352px","height":"118px","background-image":"url('https://static-s.theckb.com/BusinessMarket/SEO/activity_coupon_118.png')","background-size":"contain","display":"flex"}
}
const _hoisted_10 = {
  class: "w-[120px] flex justify-center flex-col items-center",
  style: {"width":"120px","display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"}
}
const _hoisted_11 = {
  class: "text-[38px] leading-[36px] font-bold flex items-center",
  style: {"font-size":"38px","line-height":"36px","font-weight":"700","display":"flex","align-items":"center"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-[18px] leading-[18px]",
    style: {"font-size":"18px","line-height":"18px"}
  }, "KG"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-[14px] leading-[14px]",
    style: {"font-size":"14px","line-height":"14px"}
  }, "まで")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-xl font-bold",
  style: {"font-size":"16px","line-height":"16px"}
}, "送料無料", -1)
const _hoisted_14 = {
  class: "",
  style: {"flex":"1","padding-left":"30px","display":"flex","flex-direction":"column","justify-content":"center","text-align":"left"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-2xl font-bold",
  style: {"font-size":"16px","line-height":"24px","font-weight":"600"}
}, "国際配送無料のご優待", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-base",
  style: {"font-size":"12px","line-height":"18px"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-base",
  style: {"font-size":"12px","line-height":"18px"}
}, "対象商品：人民元決済商品", -1)
const _hoisted_18 = {
  class: "text-base",
  style: {"font-size":"12px","line-height":"18px"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 特典詳細を見る ")

import { post } from '@/plugins/axios'
import { useUser } from '@/store'
import { getJapanTime } from '@/util/common'
import dayjs from 'dayjs'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { calc } from '@/util/useYan'
import confirmDialog from '@/components/common/ConfirmDialog'
import { t } from '@/plugins/i18n'

// import type { CustomerActivityRespDTO } from '~/api/types/market'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const visible = ref()
const store = useStore()

const user = useUser()

const isLogin = computed(() => store.getters.isLogin)

const coupon = ref<any>()

const route = useRoute()

onMounted(async () => {
  if (route.query.email_activity) {
    if (!isLogin.value) {
      confirmDialog({
        title: t('提示') + '!',
        text: 'ログインすると、すぐ使える送料割引クーポンを自動付与！',
        okText: t('登录'),
        cancelText: t('关闭')
      }).then(res => {
        router.push('/login?redirect=' + location.href.replace(location.origin, ''))
      })
    } else {
      const { data } = await post('/market/coupon/receiveByActivityCode?error_silent=true&activityCode=' + route.query.email_activity.toString().split('_')[0])
      console.log(data)
      if (data) {
        coupon.value = data
        visible.value = true
      }
    }
  }
})

const router = useRouter()

router.beforeEach(() => {
  visible.value = false
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "modal-class": "coupon-modal",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    top: "10vh",
    width: 400,
    "close-on-click-modal": false,
    "lock-scroll": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false)),
          style: {"position":"absolute","bottom":"-40px","left":"184px","background":"url(https://static-s.theckb.com/BusinessMarket/SEO/activity-close-circle.png)","width":"32px","background-size":"contain","cursor":"pointer","height":"32px"},
          class: "absolute bottom-[-46px] left-[184px] bg-[url(https://static-s.theckb.com/BusinessMarket/SEO/activity-close-circle.png)] w-[32px] h-[32px] bg-contain cursor-pointer"
        }),
        _hoisted_2,
        true
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (coupon.value?.activityInfo?.sceneType === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, " ※特典獲得後の初回注文は" + _toDisplayString(coupon.value?.activityInfo?.thresValue) + "元以上が条件です ", 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, " ※特典獲得後の初回注文は" + _toDisplayString(coupon.value?.activityInfo?.thresValue) + "元以上が条件です ", 1)
                  ]))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createTextVNode(_toDisplayString(coupon.value?.couponInfo?.feeToCut), 1),
              _hoisted_12
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            (!(!_unref(isLogin) && (coupon.value?.activityInfo?.endDate === '2999-01-01 00:00:00')))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(!_unref(isLogin) ? 'キャンペーン期間：' : '注文期限：') + _toDisplayString(_unref(getJapanTime)(coupon.value?.couponInfo?.effectEndTime ??
              coupon.value?.activityInfo?.endDate, 'YYYY.MM.DD')) + "まで ", 1))
              : _createCommentVNode("", true),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, "割引上限： " + _toDisplayString(coupon.value?.couponInfo?.discountValue) + "元（約" + _toDisplayString(_unref(calc)(coupon.value?.couponInfo?.discountValue)) + "円） ", 1)
          ])
        ]),
        _createVNode(_component_router_link, {
          to: `/sub/activity?id=${coupon.value?.couponInfo?.id}&t=${Date.now()}`,
          class: "block !bg-[url(https://static-s.theckb.com/BusinessMarket/SEO/activity_button.png)] !bg-contain !bg-no-repeat !w-[352px] !h-[64px] text-3xl font-bold text-center leading-[64px] mx-auto mt-[24px]",
          style: {"display":"block","background-image":"url('https://static-s.theckb.com/BusinessMarket/SEO/activity_button.png')","background-size":"contain","background-repeat":"no-repeat","width":"352px","height":"64px","font-size":"20px","font-weight":"700","text-align":"center","line-height":"64px","margin":"24px auto 0 auto","color":"#835429 !important"}
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})